import type { ElplanDraft } from './ElplanEditor.types'
import { readElplanVolume } from './volume'

export function getElplanChangedStarts(draft: ElplanDraft, seed: ElplanDraft): ReadonlySet<ISODateTime> {
  return new Set(
    draft.slotStarts.filter((start) => !isSameElplanVolume(draft.textByStart[start], seed.textByStart[start]))
  )
}

function isSameElplanVolume(text: string, seedText: string): boolean {
  if (text === seedText) {
    return true
  }

  const reading = readElplanVolume(text, 'any')
  const seedReading = readElplanVolume(seedText, 'any')
  return reading.kind === 'value' && seedReading.kind === 'value' && reading.volumeMw === seedReading.volumeMw
}
